import React from "react";
import { isNativeMobileDeviceType } from "../../../constants";
import type { ViewerDeviceRuntime } from "../../../types";
import { MESSAGE } from "./constants";

type ContentFallBackProps = {
  parcelConfig: (() => Promise<unknown>) | null;
  device: ViewerDeviceRuntime;
  children: React.ReactNode;
};

export const ContentFallBack: React.FC<ContentFallBackProps> = ({
  parcelConfig,
  device,
  children,
}) => {
  if (isNativeMobileDeviceType(device.deviceType) && !device.isOnline()) {
    return <div>{MESSAGE.network_error}</div>;
  }
  if (!parcelConfig) {
    return <div>{MESSAGE.provideWidgetConfig}</div>;
  }
  return <>{children}</>;
};
